<template>
  <v-layout align-center justify-center row fill-height>
    <v-progress-circular
      v-if="isMobile()"
      indeterminate
      color="primary"
      size="50"
      width="2"
    ></v-progress-circular>
    <v-progress-linear indeterminate v-else></v-progress-linear>
  </v-layout>
</template>

<script>
export default {
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
  },
};
</script>

<style>
</style>